/* eslint-disable no-restricted-syntax */
import Cookies from 'js-cookie';
import axios from '@shared/config/baseAPI';

const deviceId = Cookies.get('deviceId'); // change this with your device id

export const getSearchList = async (keyword, type, pageSize, sinceId = '') => {
  try {
    if (Cookies.get('token')) {
      return await axios.get(`search/list?keywords=${keyword}&type=${type}&page_size=${pageSize}&since_id=${sinceId}`, { headers: { 'device-id': `${deviceId}`, 'x-kumu-Token': Cookies.get('token'), 'x-kumu-UserId': Cookies.get('uid') } });
    }
    return await axios.get(`search/list?keywords=${keyword}&type=${type}&page_size=${pageSize}&since_id=${sinceId}`, { headers: { 'device-id': `${deviceId}` } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getSearchForward = async (keyword) => {
  try {
    if (Cookies.get('token')) {
      return await axios.get(`search/forward?keywords=${keyword}`, { headers: { 'device-id': `${deviceId}` } });
    }
    return await axios.get(`search/forward?keywords=${keyword}`, { headers: { 'device-id': `${deviceId}` } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
